<template>
  <v-main>
    <v-app-bar app flat light color="white">
      <AppbarBackIcon />
      <v-toolbar-title class="font-weight-bold">用户</v-toolbar-title>
      <v-spacer></v-spacer>
    </v-app-bar>
    <v-container fluid>
      <v-text-field label="用户ID/昵称" v-model="form.customer_key"></v-text-field>
      <div class="d-flex justify-center">
        <v-btn class="mt-4 mb-4" color="primary" :width="128" @click="onQuery">查找</v-btn>
      </div>
    </v-container>
    <div class="pb-4">
      <CustomerListItem
        v-for="customer in customerList"
        class="customer-item"
        :key="customer.id"
        :customer="customer"
        @click="onItemClick(customer.id)"
      />
    </div>
  </v-main>
</template>

<script>
import { fromUnixTime, format as formatDate } from 'date-fns'
import AppbarBackIcon from '@/components/AppbarBackIcon.vue'
import { mdiMagnify } from '@mdi/js'
import { homeStore } from '@/store/home'
import { customerStore } from '@/store/customer'
import CustomerListItem from '@/views/customer/CustomerListItem.vue'

function formatBalanceDate(date) {
  return formatDate(new Date(date), 'yyyy-MM-dd HH:mm')
}

export default {
  name: 'CustomerPage',
  components: { AppbarBackIcon, CustomerListItem },
  data() {
    return {
      mdiMagnify,
      form: {
        external_id: null,
      },
    }
  },
  computed: {
    customerList() {
      return customerStore.list
    },
  },
  async mounted() {
    await homeStore.doLoad()
  },
  methods: {
    formatBalance(balance) {
      return formatBalanceDate(fromUnixTime(balance))
    },
    formatDate(dt) {
      return formatBalanceDate(dt)
    },
    onItemClick(id) {
      this.$router.push({
        path: '/dash/customer-detail',
        query: { id },
      })
    },
    async onQuery() {
      let customer_id = this.form.customer_key
      await customerStore.doQuery({
        external_id: this.form.customer_key,
        nickname: this.form.customer_key,
        customer_id: customer_id,
      })
    },
  },
}
</script>

<style lang="less" scoped>
.customer-item {
  margin: 16px 8px 0 8px;
  padding: 8px;
}
</style>
